import type { MenuItem } from '@/consts/navigation';

export const enrichWithBadges = (items: MenuItem[], badgeMap: Map<string, string>): MenuItem[] => {
  return items.map((item) => {
    const badge = item.to !== undefined ? badgeMap.get(item.to) : undefined;
    const children = item.children ? enrichWithBadges(item.children, badgeMap) : undefined;

    if (badge === undefined && children === undefined) return item;
    if (badge === undefined && children === item.children) return item;

    return { ...item, ...(badge !== undefined ? { badge } : {}), ...(children !== undefined ? { children } : {}) };
  });
};
